import { BillingAccountService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from '../types/TCall';
import type { billingKeys } from './billingKeys';

type TParams = QueryFunctionContext<ReturnType<typeof billingKeys.tierRatesHistoryByAccount>>;

export const createFetchBillingAccountTierRatesHistoryQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ baId }], signal }: TParams) =>
    call(() => cancelOnSignal(BillingAccountService.getBillingAccountTierRatesHistory({ baId }), signal));
